<template>
  <div
    id="map-btn"
    :class="{ 'map-btn-disable': is_disabled }"
    class="map-btn map-shadow"
    @click.stop="$emit('click')"
  >
    <span class="map-btn-icon" :class="'map-btn-icon-' + name"></span>

    <slot name="map-btn-text"></slot>
    <slot name="map-btn-menu"></slot>
  </div>
</template>

<script>
export default {
  name: 'map-btn',
  props: ['name', 'title', 'is_disabled'],
  data: function() {
    return {}
  }
}
</script>

<style lang="scss" scoped>

$svg_root: '/static/images/svg';
$svg_white: invert(100%) sepia(100%) saturate(0%) hue-rotate(182deg) brightness(101%) contrast(104%);

.map-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 24px;
    height: 24px;
    font-weight: bold;
    cursor: pointer;
    background-color: #191f35;
    color: white;
}

.map-btn-icon {
    background-size: 100%;
    background-repeat: no-repeat;
}

/*disable*/
.map-btn.map-btn-disable {
    cursor: not-allowed;
}
.map-btn.map-btn-disable .map-btn-icon {
    opacity: 0.3;
}

/* 自定義icon */
.map-btn-icon-zoom_in:before {
    content: '＋';
}
.map-btn-icon-zoom_out:before {
    content: '－';
}
.map-btn-icon-small_area {
    height: 24px;
    width: 24px;
    //background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1QzRGQUM1ODI3NUMxMUU4OEI2RjkwOUU2M0RBMTQwMiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1QzRGQUM1OTI3NUMxMUU4OEI2RjkwOUU2M0RBMTQwMiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVDNEZBQzU2Mjc1QzExRTg4QjZGOTA5RTYzREExNDAyIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjVDNEZBQzU3Mjc1QzExRTg4QjZGOTA5RTYzREExNDAyIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+NwL8KgAAAUJJREFUeNpi9PT0/M/AwHAWiN8zIEDYtm3bkPlkAxYkA+8hSwgLCRHSqwnERUDcD8TX3r57h1URExmOUgfi6UB8HohTgPgq1BKqWCAJNTADiNmRxAuoZcFGIGbGIl5ODQsmAbEpDrlLlFoQBMS55KQikAXp6CkIDfAC8UoC5lzGJcH4//9/rBJIyXQHELvjMbwWiFvITaaxBAx/ADKcUBDhy4QzCDjgHDFxgAtEAzEXAf1PKbEgmIhEcokSC/SIsGA3JRZIENB7GogfUmLBLwJ620kprnG50AmH3E0gXo/PYC8vL0EgdQafDyrxyHkQ4XiQBUr4LDgFxGvQxEDZ3gGawYgui/CBGCDeicSfBcQHSS3s8IGf0OCYBuXvJKc0JQbAyhspcit9QuArED8B4pcEUo4LWiTjLq5JBbBkiS4OEGAAHBBGTDxOGmsAAAAASUVORK5CYII=');
    background-image: url($svg_root + '/focus-taiwan-24-px.svg');
    filter: $svg_white
}
.map-btn-icon-large_area {
    height: 24px;
    width: 24px;
    background-image: url($svg_root + '/focus-east-asia-24-px.svg');
    filter: $svg_white
}
.map-btn-icon-basemap {
    height: 22px;
    width: 22px;
    background-image: url($svg_root + '/selected-data-setting-copy-2.svg');
    filter: $svg_white
}
.map-btn-icon-geojson {
    height: 22px;
    width: 22px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAANySURBVEhLjVVLKHVRFN5uHkkYyMA7pCiKgUeSiYHyjKQoFAYUSkrII2QieQ0lAxNvBgYKA0qR50gxkXchIm/i+89azrnOOXdf/V99d++zzrfWunuvdfYW+AOvr6/o7OxERkYG/Pz8IIRg+vr6sq2pqQl3d3eqWg5pgpubG6SkpCAmJgaFhYV4enrC2toaLBYLJ3BwcEBcXBwuLi7Q0NCA9PR0nstgk2BwcBClpaVITU3F1NQUFhcXkZaWxoG9vb3h7OyMwMBA5OTkqB4/qKysRHd3t/r0C0OCtrY29PT0oKSkxLod/v7+PEZERGBra4t1ExMTPJrR1dWFqqoq9ekH1gSjo6NwdXVFeHi4NTgxOzubx+XlZSQnJ6tq+2hvbzeshBO8v78bgupZW1uLyclJ3mPZPn99feHz8xOPj4+qBSguLsbl5SXPOUFmZqY0OG3L8PAwXl5ecHp6yg5XV1coLy/nwpeVleH6+hrf39/8Tg8qPIETyIIT9/f3ORjNCwoKsLq6ir6+PqysrGB9fR0bGxvo7e3lQGbU1NTg/v4eor+/3yYwkXr96OgIx8fH2N7ettrd3NwQGxurhrGPmZkZNDY2QuTm5hoCE6nHzdjZ2WHOz88buqi1tRVLS0vY3d3lehCGhob4A+TYUVFRhuCOjo54e3tjoT3Q0qurq3l+fn6Og4MDuLu7sz8hPz8fXl5eSExMhCU0NFSx/yI4OFi4uLioT3J4enoKpXPE4eGhUI4Q8fDwIJQu4nfK0SI+Pj7E7e2tULZYCCqaYreSOud/UVdXh5aWFoM/MS8vD05OTnxeiY6ODkRHRxsEs7Ozaoi/Qf1/dnaGoKAgg7/GhIQEWJT+Fnt7e8rzL5TiiLCwMOHh4SGU9lSttlDqJebm5sTJyYlqMcLHx0eI+vp6/jfmVehJX7oeCwsLPI6MjEj1GgcGBiCoI5qbmxESEiIVESsqKjigBqW4PMq0erKGfoqKipCUlCQVadSD2phWRQ2hdCEX1Kyn44fAns/PzzYCPTWxHtPT0wgICMDm5qbUR9tW618bGxuTCjVqpyOBDjey0cVEt55ZS7E0GNZOLWsWa4yMjFRVQHx8vFRDpBh6GDdXwfj4uNSRSBcS3ceyd0TyNcMmAYGKmJWVJQ0iI2ntnV/SBHrQcU6fvnY3E2lONnr3N4B/8MCE3uqPiekAAAAASUVORK5CYII=');
}
.map-btn-icon-boundary {
    height: 22px;
    width: 22px;
    background-image: url($svg_root + '/geographic-info-24-px.svg');
    filter: $svg_white
}
.map-btn-icon-order {
    height: 24px;
    width: 24px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAIAAAADwcZiAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAQcSURBVFhH7ZhHSyxNFIZNiCsVc8K8cPu5N4A556wrQXe61KUgIgZEVBTDTnApqD9BzDmLoq5FN+aI8z19T9O0Mz3jjPd6V/fdOH3q1Hm6qk6dqtbZZDI5/XW5qH//rv5Rbeji4qKmpsbZ2TkuLq65uZlHtcEhkU126vj4uLa21sVFedH/fokfrq6uGE9PT1Un+2QX9ejoqLq6WnipqalLS0tin5+fT0tLw0gTDvazv6Du7+9XVlYKLyMjY21tTW3QaXFxkSZh48yUqA3WZZW6t7dXVlbG+hEuKytrc3NTbbCi5eVl3HCmS3l5uW22AXV7e7ukpIT+KDc390ueXqurqzk5OcImyMHBgdrwWZ+oAAoLC4WXn5+/u7urNjio9fV1ugu7qKjIkq1SNzY2ND/A3+bppY2BmAUFBfqYCnV0dJQGZGNOvq2tra3i4mJhAxKjQg0ICIiNjbUn974tBgPC399fHhVqQkLCDw1UtLOzI+mZmJgoFoV6eXkpmwT9qUUVMb1kk0wv2+n6+lrsajYhKktKSgoe6HcSWKSlJ0pPTzcrWyr15uampaXF3d0dp4iICPF2dLOK2LJ0lAgSysPDo7W19fb2VvUQ6srKCutMMws+NTX18fHBSpSWlv7q6JSdnW0nm/KEM12YT8kSQhEwKioKIzk7NzcnngoVKybS+u3tTawiiiKLQQj6ZGZmGhZhEaUYB9woxZblkLAjIyNeXl6hoaFiUagxMTGYBgcHn5+fxaoXr6wdAKyQGVt/7Fgr/U9PTwRnOsPCwsSiUDm5ZIaDg4P7+/sN2frDjko7MzMzOzsrRw1HLOe84TEHj4CBgYG4gfg0w0ifTUFBQX19fXSQJr0YSl1dnbARPB7Pz8/VZp0eHx8JIoMxziYRLytzJeIFe3t7DdlXV1eTk5NtbW1MgGrS6eHhgY7CExnvHKqEZI2bm1tjYyPvPjAwoE1Ld3c3Ly7etnV/f9/V1eXj40PHkJAQgpydnTU0NDAlBKcQaWyFmpSUhLWqqko/V6zu0NAQK00IPz+/zs5OgqptFrq7u8NBeKQMHV9fX9U2k+nk5KSiooKm+Ph4sShUBsRONSzCLy8vJL2wfX19Ozo6zNisFkZvb28cwsPDh4eH9TxNUv09PT3lUaESlz4M1/AERrDZzQwCNwA9PT1kHzzGRyCMkZGRlttdxM1ETjrU3t4uRjWbKJscvDTANjuBNTGI8fFxBiQhRNHR0RMTE+/v76qTTjZuJipVpB0RKC8vz5ANYHp6ur6+Pjk5eWxszJBndoOxjPOJKtKOQ0RBcOgA+M5tTS9Hb6YUuN+6meolt3BhW7uFLyws/LFbuF6Hh4daEaZ+aeyf+uLQi0Hov67Y8vz4wa8rvQA0NTVxOIJkfIal/0v9+7/Ez8rJ6X/BJMjt20E84wAAAABJRU5ErkJggg==');
}
.map-btn-icon-opacity {
    height: 24px;
    width: 24px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAA00lEQVR4AcXLtVkFYRBG4YO7kxGS4CHu1IDTAq4ZtEIJWIS7O7SAe747uM7PdXknm+c7BE3Ry7mhmEceKHJnLoirSQkvc2aYdS0p4QlhnhjiWNaJeb5EHAAJbDhOCnhEWCWeT8ns8ZKQg0Y4pwibJPJTGscIB4ShtCGck67+GdwiNKFMIXRjMoQwjnKFkIlJNsI5io0QjkkUgoXyhDi4B5Q1h8EyyqDDoBcllft/5zckgdb6b9AAZr3YamzRgQN1nPyaH1IFjoVQyQijLzdMOSEE3DPOtJOO5PRNSQAAAABJRU5ErkJggg==');
}
.map-btn-icon-capture {
    height: 26px;
    width: 26px;
    background-image: url($svg_root + '/screen-shot-24-px.svg');
    filter: $svg_white
}
.map-btn-icon-measure {
    height: 24px;
    width: 24px;
    background-image: url($svg_root + '/set-square-24-px.svg');
    filter: $svg_white
}
</style>
